import { IPublicSession } from 'state/session';
import { State } from 'utils/state';

export function experienceSwitchingSanitation(state: State<IPublicSession>) {
  state.on('beforechange', (keys, arrValues, arrOldValues, sessionChanges) => {
    // When switching to 2D, clear aveSessionId and aveChannelName atomically with the experience change.
    // Mutating sessionChanges + keys directly (instead of re-entrant setValues) ensures
    // both fields are committed in the same setValues call and appear in the change event.
    // This prevents syncToServer from flushing stale activeExperience='3D' during a
    // re-entrant change event, which caused 3D→2D switches to revert.
    if (keys.includes('activeExperience') && sessionChanges.activeExperience === '2D') {
      const oldAveSessionId = state.get('aveSessionId');
      if (oldAveSessionId !== '') {
        sessionChanges.aveSessionId = '';
        keys.push('aveSessionId');
        arrValues.push('' as IPublicSession[keyof IPublicSession]);
        arrOldValues.push(oldAveSessionId as IPublicSession[keyof IPublicSession]);
      }

      const oldAveChannelName = state.get('aveChannelName');
      if (oldAveChannelName !== '') {
        sessionChanges.aveChannelName = '';
        keys.push('aveChannelName');
        arrValues.push('' as IPublicSession[keyof IPublicSession]);
        arrOldValues.push(oldAveChannelName as IPublicSession[keyof IPublicSession]);
      }
    }
  });
}
